import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { TransactionStatus } from '../service-proxies';


export class Admin_Dashboard_Daily_Leave_Application implements IAdmin_Dashboard_Daily_Leave_Application {
    employee!: EmployeeSummaryDto;
    leaveName!: string | undefined;
    reason!: string | undefined;
    leaveRequestDate!: Date | undefined;
    approver!: EmployeeSummaryDto;
    fromDate!: Date | undefined;
    toDate!: Date | undefined;
    leaveStatus!: TransactionStatus;

    constructor(data?: IAdmin_Dashboard_Daily_Leave_Application) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.leaveName = _data["leaveName"];
            this.reason = _data["reason"];
            this.leaveRequestDate = _data["leaveRequestDate"] ? new Date(_data["leaveRequestDate"].toString()) : <any>undefined;
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.leaveStatus = _data["leaveStatus"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Daily_Leave_Application {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Daily_Leave_Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["leaveName"] = this.leaveName;
        data["reason"] = this.reason;
        data["leaveRequestDate"] = this.leaveRequestDate ? this.leaveRequestDate.toISOString() : <any>undefined;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["leaveStatus"] = this.leaveStatus;
        return data; 
    }
}

export interface IAdmin_Dashboard_Daily_Leave_Application {
    employee: EmployeeSummaryDto;
    leaveName: string | undefined;
    reason: string | undefined;
    leaveRequestDate: Date | undefined;
    approver: EmployeeSummaryDto;
    fromDate: Date | undefined;
    toDate: Date | undefined;
    leaveStatus: TransactionStatus;
}

